import { render } from "./navBar.vue?vue&type=template&id=54344b3f&scoped=true"
import script from "./navBar.vue?vue&type=script&lang=js"
export * from "./navBar.vue?vue&type=script&lang=js"

import "./navBar.vue?vue&type=style&index=0&id=54344b3f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54344b3f"]])

export default __exports__